import { lazy, type ComponentType } from "react";

const loaders = {
  Index: () => import("./pages/Index"),
  CompoundsPage: () => import("./pages/Compounds"),
  CompoundDetail: () => import("./pages/CompoundDetail"),
  AboutPage: () => import("./pages/About"),
  BlogPage: () => import("./pages/Blog"),
  BlogPost: () => import("./pages/BlogPost"),
  PrivacyPolicy: () => import("./pages/PrivacyPolicy"),
  TermsOfService: () => import("./pages/TermsOfService"),
  ResearchDisclaimer: () => import("./pages/ResearchDisclaimer"),
  IntelligenceHub: () => import("./pages/Intelligence"),
  IntelligenceArticle: () => import("./pages/IntelligenceArticle"),
  NotFound: () => import("./pages/NotFound"),
  RetatrutideTracker: () => import("./pages/RetatrutideTracker"),
  CompareGlp1: () => import("./pages/CompareGlp1"),
  Glp1Cost: () => import("./pages/Glp1Cost"),
  PolicyPage: () => import("./pages/Policy"),
  ResearchRetatrutide: () => import("./pages/ResearchRetatrutide"),
  Disclosures: () => import("./pages/Disclosures"),
  EditorialPolicy: () => import("./pages/EditorialPolicy"),
  PeptideHorizon: () => import("./pages/PeptideHorizon"),
  HhsPolicy: () => import("./pages/HhsPolicy"),
  HhsProposal: () => import("./pages/HhsProposal"),
  Comparison503: () => import("./pages/Comparison503"),
  Lipfendra: () => import("./pages/Lipfendra"),
  HhsPeptideDraftPolicy: () => import("./pages/HhsPeptideDraftPolicy"),
  FoundayoVsWegovyPill: () => import("./pages/FoundayoVsWegovyPill"),
  CagrisemaResults: () => import("./pages/CagrisemaResults"),
  CompoundedSemaglutideStatus: () => import("./pages/CompoundedSemaglutideStatus"),
  CompoundedTirzepatideStatus: () => import("./pages/CompoundedTirzepatideStatus"),
  RfkPeptides: () => import("./pages/RfkPeptides"),
  AlertsHub: () => import("./pages/AlertsHubPage"),
  AlertDetail: () => import("./pages/AlertDetailPage"),
};

type PageName = keyof typeof loaders;
const serverPages: Partial<Record<PageName, ComponentType>> = {};

export async function preloadPrerenderPages() {
  await Promise.all(Object.entries(loaders).map(async ([name, load]) => {
    serverPages[name as PageName] = (await load()).default;
  }));
}

function page(name: PageName) {
  const LazyPage = lazy(loaders[name]);
  return function RoutePage() {
    const Page = import.meta.env.SSR ? serverPages[name] : LazyPage;
    if (!Page) throw new Error(`Prerender page not preloaded: ${name}`);
    return <Page />;
  };
}

export const Index = page("Index");
export const CompoundsPage = page("CompoundsPage");
export const CompoundDetail = page("CompoundDetail");
export const AboutPage = page("AboutPage");
export const BlogPage = page("BlogPage");
export const BlogPost = page("BlogPost");
export const PrivacyPolicy = page("PrivacyPolicy");
export const TermsOfService = page("TermsOfService");
export const ResearchDisclaimer = page("ResearchDisclaimer");
export const IntelligenceHub = page("IntelligenceHub");
export const IntelligenceArticle = page("IntelligenceArticle");
export const NotFound = page("NotFound");
export const RetatrutideTracker = page("RetatrutideTracker");
export const CompareGlp1 = page("CompareGlp1");
export const Glp1Cost = page("Glp1Cost");
export const PolicyPage = page("PolicyPage");
export const ResearchRetatrutide = page("ResearchRetatrutide");
export const Disclosures = page("Disclosures");
export const EditorialPolicy = page("EditorialPolicy");
export const PeptideHorizon = page("PeptideHorizon");
export const HhsPolicy = page("HhsPolicy");
export const HhsProposal = page("HhsProposal");
export const Comparison503 = page("Comparison503");
export const Lipfendra = page("Lipfendra");
export const HhsPeptideDraftPolicy = page("HhsPeptideDraftPolicy");
export const FoundayoVsWegovyPill = page("FoundayoVsWegovyPill");
export const CagrisemaResults = page("CagrisemaResults");
export const CompoundedSemaglutideStatus = page("CompoundedSemaglutideStatus");
export const CompoundedTirzepatideStatus = page("CompoundedTirzepatideStatus");
export const RfkPeptides = page("RfkPeptides");
export const AlertsHub = page("AlertsHub");
export const AlertDetail = page("AlertDetail");
